export enum ScoutSearchStorageKey {
  SEARCH_OPTION_PARAM = "scoutCandidate:searchOptionParam",
  SAVED_SEARCH_OPTION = "scoutCandidate:savedSearchOption"
}

export enum AgentScoutSearchStorageKey {
  SEARCH_OPTION_PARAM = "agentScoutCandidate:searchOptionParam",
  SAVED_SEARCH_OPTION = "agentScoutCandidate:savedSearchOption"
}
